import { supportLocalStorage, supportAspectRatio } from './browser-support.js';

const support = {
  supportLocalStorage: supportLocalStorage,
  supportAspectRatio: supportAspectRatio
};

export default support;
